import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import moment from 'moment-timezone';
import { LyftDispatchRideStatus } from './lyft-dispatch-ride-status';
import { RideRequestType } from './ride-request-type';

export class LyftDispatchRideTracker {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  riderName: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserializeAs(Date)
  cancelledDate: Date;

  @autoserialize
  rideRequestCancelled: boolean;

  @autoserialize
  timeZone: string;

  @autoserialize
  lyftDispatchRideId: number;

  @autoserialize
  lyftRideId: string;

  @autoserializeAs(LyftDispatchRideStatus)
  lyftDispatchRideStatus: LyftDispatchRideStatus;

  @autoserializeAs(Date)
  itineraryPickupDate: Date;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserializeAs(Date)
  activatedAt: Date;

  @autoserializeAs(Date)
  recoveryRideCreatedDate: Date;

  get displayDate(): Date {
    if (this.rideRequestType.onDemand) {
      return this.pickupDate;
    }
    return this.itineraryPickupDate;
  }

  /**
   * TODO: Refactor later using https://www.npmjs.com/package/localdate
   */
  get formattedDisplayDate(): string {
    if (!this.rideRequestType.onDemand) {
      return moment.tz(this.pickupDate, this.timeZone).format('M/DD/YY h:mm a (z)');
    }
    return moment(this.itineraryPickupDate).format('M/DD/YY');
  }

  static OnSerialized(instance: LyftDispatchRideTracker, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.itineraryPickupDate)) {
      json.itineraryPickupDate = DateUtil.serializeLocalDate(instance.itineraryPickupDate);
    }

    if (!isNullOrUndefined(instance.activatedAt)) {
      json.activatedAt = DateUtil.serializeDate(instance.activatedAt);
    }

    if (!isNullOrUndefined(instance.recoveryRideCreatedDate)) {
      json.recoveryRideCreatedDate = DateUtil.serializeDate(instance.recoveryRideCreatedDate);
    }
  }

  static OnDeserialized(instance: LyftDispatchRideTracker, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['itineraryPickupDate'])) {
      instance.itineraryPickupDate = DateUtil.deserializeLocalDate(json['itineraryPickupDate']);
    }

    if (!isNullOrUndefined(json['activatedAt'])) {
      instance.activatedAt = DateUtil.deserializeDate(json['activatedAt']);
    }

    if (!isNullOrUndefined(json['recoveryRideCreatedDate'])) {
      instance.recoveryRideCreatedDate = DateUtil.deserializeDate(json['recoveryRideCreatedDate']);
    }
  }
}
